module.exports = __webpack_public_path__ + "img/logo_toyota.bad68470.png";